// import core & vendor packages below
import { Container, Row } from 'react-bootstrap';

// import components below
import Layout from 'components/Layout';
import CreateTemporaryProfileHeader from './PageHeader';
import FormCreateTemporaryProfile from 'components/FormCreateTemporaryProfile';

// main component
const CreateTemporaryProfile = () => {
  return (
    <Layout pageTitle='Admissions'>
      <CreateTemporaryProfileHeader />
      <Container fluid>
        <Row>
          <FormCreateTemporaryProfile />
        </Row>
      </Container>
    </Layout>
  );
};

export default CreateTemporaryProfile;
